
export class CustomerCharacteristicAttribute {
    public id: number;
    public customerCharacteristicID: number;
    public customerCharacteristicAttributeTypeId: number;
    public customerCharacteristicAttributeValue: string;
    public effectiveDate: any;
    public endDate: any;

    public updatedBy: string;
    public updatedDate: any;
}
